














































// @ts-nocheck
import Vue from 'vue';
import { PersonInfoStore, DetailStore } from '@/store/index';
import { FitForm, FitFormItem, FitInput, FitButton, FitCheckbox } from '@tencent/wphk-ui';
import charity from '@/business/charity';
import { biHottag } from '@tencent/ppd-base-libs';
import { getOrganByOid } from '@/business/cfg';

export default Vue.extend({
  name: 'personInfo',
  data() {
    return {
      PersonInfoStore,
      DetailStore,
      checkVal: '',
      htmlCheckLabel: '',
    };
  },
  activated() {
    const organ = getOrganByOid(DetailStore.oid);
    this.checkVal = organ.checkVal || '';
    this.htmlCheckLabel = organ.checkLabel || '';
    biHottag('wallet.charity.info.index_view');
  },
  methods: {
    handleSwitchNeedNotice() {
      PersonInfoStore.receive_notify = PersonInfoStore.receive_notify === '0' ? '1' : '0';
      biHottag('wallet.charity.info.news_click');
    },
    handleClickConfirm() {
      if (!PersonInfoStore.btnActive) {
        return;
      }
      biHottag('wallet.charity.info.pay_click');
      charity.orderReq();
    },
    skipConfirm() {
      biHottag('wallet.charity.info.pay_skip');
      charity.orderReq(true);
    },
    eBlur() {
    },
    eInput(val, name) {
      charity.handleInputVal(val, name);
      this.hightlightBtn();
    },
    hightlightBtn() {
      if (!PersonInfoStore.donor_name || !PersonInfoStore.donor_name.trim()) {
        PersonInfoStore.btnActive = false;
        return;
      }
      if (!PersonInfoStore.donor_email) {
        PersonInfoStore.btnActive = false;
        return;
      }
      // 电邮要符合一定规则
      const reg = /^[A-Za-z0-9.\-_]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!reg.test(PersonInfoStore.donor_email)) {
        PersonInfoStore.btnActive = false;
        return;
      }
      if (!PersonInfoStore.donor_phone) {
        PersonInfoStore.btnActive = false;
        return;
      }
      if (PersonInfoStore.donor_phone.length < 8 || PersonInfoStore.donor_phone.length > 11) {
        PersonInfoStore.btnActive = false;
        return;
      }
      PersonInfoStore.btnActive = true;
    },
  },
  components: {
    FitForm,
    FitFormItem,
    FitInput,
    FitButton,
    FitCheckbox,
  },
  created() {
    charity.getDonorQry(() => {
      this.hightlightBtn();
    });
  },
});
